import useTrans from "@/hooks/useTrans";
import styles from "./notFound.module.scss";

/**
 * Shown when a page could not render (see errorBoundary.js and pages/500.tsx).
 *
 * Both actions are full page loads rather than next/link navigations: whatever
 * broke may be client state, and a fresh load is the reliable way out of it.
 */
export default function ErrorScreen() {
  const trans = useTrans();

  return (
    <section className={styles.wrapper} role="alert" aria-labelledby="error-screen-title">
      <div className={styles.content}>
        <svg
          className={styles.icon}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <h1 id="error-screen-title" className={styles.title}>
          {trans.errorScreen.title}
        </h1>
        <p className={styles.description}>{trans.errorScreen.description}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.primary} onClick={() => window.location.reload()}>
            {trans.errorScreen.reload}
          </button>
          <button type="button" className={styles.secondary} onClick={() => window.location.assign("/")}>
            {trans.errorScreen.backHome}
          </button>
        </div>
      </div>
    </section>
  );
}
